<template>
  <div class="card m-4 max-height d-flex align-items-center shadow-lg" style="width: 18rem;">
    <div class="card-body">
      <h5 class="card-title">
        {{ pais.name.common }} {{ pais.flag }}
      </h5>
      <img
        :src="pais.flags[0]" 
        class="card-img-top p-1 border" 
        :title="pais.name.common" 
        :alt="pais.name.common"
      >
      <p class="card-text text-start mt-3">
        Capital: 
        <span class="badge bg-info text-dark">
          {{ pais.capital[0] }}
        </span></p>
      <p class="card-text text-start">
        Region: 
        <span class="badge bg-info text-dark"> 
          {{ pais.region }}
        </span></p>
      <p class="card-text text-start">
        Población: 
        <span class="badge bg-info text-dark"> 
          {{ format(pais.population) }}
        </span></p>
      <a :href="pais.maps.googleMaps" target="blank" class="btn btn-outline-success">
        Learn more about {{ pais.flag }}
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pais: {
      type: Object,
      default: null
    }
  },
  setup() {
    const format = (number) => {
      return new Intl.NumberFormat("de-DE").format(number)
    }
    return { format }
  }
}
</script>
<style scoped>
.max-height {
  min-height: 450px;
}
  
</style>